export interface LawyerPartner {
  id: string;
  name: string;
  oab: string;
  role: string;
  specialties: string[];
  photo: string;
  bio: string;
}

export interface LawBlogPost {
  id: string;
  title: string;
  category: string;
  readTime: string;
  date: string;
  author: string;
  summary: string;
  content: string;
}

export interface LawCaseProcess {
  id: string;
  processNumber: string;
  court: string;
  clientName: string;
  subject: string;
  status: 'Em Andamento' | 'Concluso para Sentença' | 'Recurso Protocolado' | 'Fase de Execução';
  lastUpdate: string;
  nextDeadline: string;
}

export const advocaciaSocios: LawyerPartner[] = [
  {
    id: 'socio_001',
    name: 'Dr. Henrique Vanguard',
    oab: 'OAB/SP 142.890',
    role: 'Sócio Fundador & Head de Direito Tributário',
    specialties: ['Holding Familiar', 'Reestruturação Tributária', 'M&A'],
    photo: 'https://images.unsplash.com/photo-1556157382-97eda2d62296?q=80&w=400&auto=format&fit=crop',
    bio: 'Mestre em Direito Tributário pela USP com mais de 20 anos de atuação em reestruturações societárias de grande porte.'
  },
  {
    id: 'socio_002',
    name: 'Dra. Beatriz Montebello',
    oab: 'OAB/SP 210.450',
    role: 'Sócia & Head de Direito Corporativo',
    specialties: ['Contratos Internacionais', 'Governance & Compliance', 'LGPD'],
    photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=400&auto=format&fit=crop',
    bio: 'Especialista em governança corporativa e mediação de conflitos societários complexos.'
  }
];

export const advocaciaBlogPosts: LawBlogPost[] = [
  {
    id: 'post_001',
    title: 'Planejamento Sucessório e Holding Familiar: Como Proteger o Patrimônio da Família',
    category: 'Direito de Família & Patrimonial',
    readTime: '6 min de leitura',
    date: '18 de Outubro, 2026',
    author: 'Dr. Henrique Vanguard',
    summary: 'Entenda os benefícios fiscais e jurídicos de constituir uma holding patrimonial para evitar inventários demorados e custos tributários elevados.',
    content: 'A constituição de uma Holding Familiar tornou-se a ferramenta mais eficaz de proteção patrimonial no Brasil. Além de evitar o moroso processo de inventário judicial, a holding permite uma redução expressiva no ITCMD e na tributação sobre aluguéis e ganho de capital...'
  },
  {
    id: 'post_002',
    title: 'Reforma Tributária e os Impactos no Setor de Serviços e Tecnologia em 2027',
    category: 'Direito Tributário',
    readTime: '8 min de leitura',
    date: '12 de Outubro, 2026',
    author: 'Dra. Beatriz Montebello',
    summary: 'Análise detalhada da transição do IBS e CBS para empresas do setor de tecnologia e serviços de alto valor agregado.',
    content: 'Com a regulamentação da Reforma Tributária, as empresas do setor terciário precisam readequar suas estruturas de precificação e planejamento fiscal...'
  }
];

export const advocaciaProcessos: LawCaseProcess[] = [
  {
    id: 'proc_101',
    processNumber: '1048291-44.2025.8.26.0100',
    court: '2ª Vara de Falências e Recuperações - TJSP',
    clientName: 'Grupo Varejista Alfa S.A.',
    subject: 'Recuperação Judicial & Repactuação de Passivo',
    status: 'Em Andamento',
    lastUpdate: 'Petição de juntada do plano de recuperação protocolada com sucesso.',
    nextDeadline: '24/10/2026 - Assembleia Geral de Credores'
  },
  {
    id: 'proc_102',
    processNumber: '5029381-12.2024.4.03.6100',
    court: '4ª Vara Cível Federal de São Paulo',
    clientName: 'Tecnologia & Logística LTDA',
    subject: 'Ação Anulatória de Débito Fiscal (Tributário)',
    status: 'Concluso para Sentença',
    lastUpdate: 'Autos conclusos para julgamento do juiz titular.',
    nextDeadline: '02/11/2026 - Publicação no Diário Eletrônico'
  }
];
